const styles = theme => ({
  container: {
    '& $gridItem': {
      '& p': {
        color: theme.palette.primary.dim,
      },
      '& h6': {
        color: theme.palette.primary.adgmBlack,
        fontWeight: 600,
      },
    },
  },
  gridItem: {},
  border: {
    borderRight: '1px solid #EBEEF3',
    borderLeft: '1px solid #EBEEF3',
  },

  '@media (max-width: 959px)': {
    container: {
      '& $gridItem': {
        border: 'none',
        borderTop: '1px solid #EBEEF3',
        '&:first-child': {
          borderTop: 'none',
        },
      },
    },
  },

  '@media (max-width: 767px)': {
    container: {
      '& $gridItem': {
        '& p': {
          fontSize: '12px',
        },
        '& h6': {
          fontSize: '12px',
          fontWeight: 500,
        },
      },
    },
  },
});

export default styles;
